import { IonSkeletonText } from '@ionic/react'
import React, { FC } from 'react'

const EventCardSkeleton: FC = () => {
	return (
		<div className='flex flex-row gap-4 h-[4.5rem]'>
			<IonSkeletonText animated className='rounded-lg m-0 bg-[#f4f4f4] h-[4.5rem] w-[4.5rem]' />

			<div className='flex flex-col justify-center gap-2'>
				<IonSkeletonText animated className='rounded-lg m-0 bg-[#f4f4f4] h-[1.25rem] w-[8rem]' />
				<IonSkeletonText animated className='rounded-lg m-0 bg-[#f4f4f4] h-[1rem] w-[6rem]' />
			</div>
		</div>
	)
}

export default EventCardSkeleton
